import { Logo } from "./Logo";
import { useRegistration } from "@/context/RegistrationContext";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

export const PortalHeader = ({ showSaveStatus = true }) => {
  const { saveStatus } = useRegistration();
  return (
    <header
      className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-[#E5E7EB]"
      data-testid="portal-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-home-link">
          <Logo withText />
        </Link>
        <div className="flex items-center gap-3">
          {showSaveStatus && (
            <div
              className="hidden sm:flex items-center gap-2 text-xs text-[#6B7280] px-3 py-1.5 rounded-full bg-[#F7F7F7]"
              data-testid="save-status"
            >
              {saveStatus === "saving" && (
                <>
                  <Loader2 className="h-3.5 w-3.5 animate-spin" />
                  <span>Saving…</span>
                </>
              )}
              {saveStatus === "saved" && (
                <>
                  <CheckCircle2 className="h-3.5 w-3.5 text-green-600" />
                  <span>Saved to Drafts</span>
                </>
              )}
              {saveStatus === "idle" && (
                <>
                  <CheckCircle2 className="h-3.5 w-3.5 text-[#9CA3AF]" />
                  <span>Auto-save on</span>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
